import script from "./PwaInstall.vue?vue&type=script&setup=true&lang=js"
export * from "./PwaInstall.vue?vue&type=script&setup=true&lang=js"

import "./PwaInstall.vue?vue&type=style&index=0&id=45a8f0c6&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\hndypro-vue-L12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a8f0c6"]])

export default __exports__